export namespace NavBarStates {
    export function navBarStatesFactory() {
        const navBar = {
            current: 'home',
            burgerMenuVisible: false,
            timestamp: new Date()
        };
        return navBar;
    }

    export function mutations() {
        return {
            invokeHeaderBurger(state: any) {
                state.navBar.burgerMenuVisible = true;
                state.navBar.timestamp = new Date();
            },
            sleepHeaderBurger(state: any) {
                state.navBar.burgerMenuVisible = false;
                state.navBar.timestamp = new Date();
            },
            navTo(state: any, section: string) {
                state.navBar.current = section;
                state.navBar.timestamp = new Date();
            },
        };
    }
}
